import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { useLocation, useNavigate, useParams } from "react-router-dom";

import { toast } from "react-toastify";
import { ThreeDots } from "react-loader-spinner";
import { postSendEmail } from "../../services/Login/sendEmail";

const SendEmail = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { id } = useParams(); //get id
  const { doc } = location.state; //get doc
  const { register, handleSubmit, reset } = useForm();

  const [loading, setLoading] = useState(false);

  const onSubmit = async ({ email }) => {
    setLoading(true);

    const data = {
      email: email,
      environment_id: doc.id_environment,
      type: "sistema"
    };

    try {
      const response = await postSendEmail(data);

      toast.success(response.success);
      navigate("/");
    } catch (error) {
      toast.error("Falha ao enviar e-mail, tente novamente!");
      reset({ email: "" });
    } finally {
      setLoading(false);
    }
  };
  return (
    <div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <p>Informe um e-mail para redefinir a senha: </p>
        <div className="form-floating mb-20px position-relative">
          <input
            autoFocus
            id="email"
            className="form-control fs-13px h-45px"
            type="email"
            {...register("email")}
          />

          <label htmlFor="email" className="d-flex align-items-center py-0">
            E-mail
          </label>
        </div>
        <div className="login-buttons">
          <button
            type="submit"
            disabled={loading}
            className="btn h-45px btn-blue d-flex align-items-center justify-content-center w-100 btn-lg"
          >
            {loading ? (
              <ThreeDots
                height="80"
                width="80"
                radius="9"
                color="#fff"
                ariaLabel="three-dots-loading"
                wrapperStyle={{}}
                wrapperClassName=""
                visible={true}
              />
            ) : (
              <>Enviar</>
            )}
          </button>

          <div className="text-center pt-2">
            <b>
              <div
                style={{
                  cursor: "pointer",
                  textDecoration: "underline",
                }}
                onClick={() => navigate("/")}
                className="text-gray bg-transparent border-none"
              >
                Entrar <i className="fas fa-arrow-right ml-1"></i>
              </div>
            </b>
          </div>
        </div>
      </form>
    </div>
  );
};

export default SendEmail;
